import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import {MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-folder-dialog',
  templateUrl: './add-folder-dialog.component.html',
  styleUrls: ['./add-folder-dialog.component.css']
})
export class AddFolderDialogComponent implements OnInit {
  media: any = {};

  constructor(private _snackBar: MatSnackBar, private snotifyService: ToastrService, private httpClient: HttpClient, public dialogRef: MatDialogRef<AddFolderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      
    }

  ngOnInit() {

    if (this.data.folder && this.data.folder.name) {
      this.media.name = this.data.folder.name;
      this.media.orgName = this.data.folder.name;
    }
  }

  saveMedia(form) {

    if (form.invalid)
      return

    if (this.data.folder && this.data.folder.name) {
      var data = { Path: this.data.path + "/" + this.media.orgName, FolderName: this.data.path + "/" + this.media.name };
      this.httpClient.post('/Media/RemaneFolder', data).subscribe((res: any) => {
        this.dialogRef.close("has been Renamed");
      });
    } else {
      var data2 = { Path: this.data.path, FolderName: this.media.name };
      this.httpClient.post('/Media/CreateFolder', data2).subscribe((res: any) => {
        this.dialogRef.close("has been added");
      });
    }


  }


  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
    timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  close() {
    this.dialogRef.close();
  }




}
